import React from 'react';
import { observer } from "mobx-react";
import { Form, InputNumber, Select, Space } from 'antd';

const SHAPES = [
    { value: 'rect', label: 'Rectangular' },
    { value: 'round', label: 'Round' },
];

@observer
export class RugVariantSpecific extends React.Component {
    render() {
        const { variant, onChange } = this.props;
        const shape = variant.typeSpecific.shape || 'rect';
        const isRound = shape === 'round';
        const setWidth = (v) => {
            onChange('width', v);
            if (isRound) onChange('height', v);
        };
        return (
            <>
                <Form.Item label="Shape">
                    <Select
                        size="small"
                        value={shape}
                        options={SHAPES}
                        onChange={(v) => {
                            onChange('shape', v);
                            if (v === 'round' && variant.typeSpecific.width != null) {
                                onChange('height', variant.typeSpecific.width);
                            }
                        }}
                        style={{ width: 140 }}
                    />
                </Form.Item>
                <Form.Item label="Size (inches)">
                    <Space>
                        <InputNumber
                            size="small"
                            step={0.1}
                            placeholder={isRound ? 'Diameter' : 'Width'}
                            value={variant.typeSpecific.width}
                            onChange={setWidth}
                            addonBefore={isRound ? 'D' : 'W'}
                            style={{ width: 110 }}
                        />
                        {!isRound && (
                            <InputNumber
                                size="small"
                                step={0.1}
                                placeholder="Depth"
                                value={variant.typeSpecific.height}
                                onChange={(v) => onChange('height', v)}
                                addonBefore="H"
                                style={{ width: 110 }}
                            />
                        )}
                    </Space>
                </Form.Item>
            </>
        );
    }
}
